import { useState, useEffect, useRef, useContext } from "react";
import "./header.scss";
import logo from "../../assets/img/logo.svg";
import Icon from "../Icon/Icon";
import classNames from "classnames";
import Menu from "./Menu";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

function Header(): JSX.Element {
  const [isShowWalletModal, setIsShowWalletModal] = useState(false);
  const [isShowSideMenu, setIsShowSideMenu] = useState(false);
  const showSideMenuClazz = classNames("header", {
    "show-side-menu": isShowSideMenu,
    "close-side-menu": !isShowSideMenu,
  });
  const location = useLocation();
  const linkRefOne = useRef(null);
  const linkRefTwo = useRef(null);
  const showSideMenu = () => {
    setIsShowSideMenu(true);
  };
  const showWalletModal = () => {
    setIsShowWalletModal(true);
  };
  // const onGoPro = () => {
  //   ga("gsw_pro", "gsw_pro", "go_pro_web");
  // };


  return (
    <div className={showSideMenuClazz}>
      <div className="left">
        <div className="small-menu" onClick={showSideMenu}>
          <Icon token="menu" />
        </div>
        <a href="https://deri.io/#/index">
          <div className="logo">
            <img src={logo} alt="logo" />
            <span className="name">DERI</span>
          </div>
        </a>
        <Menu closeSideMenu={() => setIsShowSideMenu(false)} />
      </div>

      <div className="right">
        <Link className="work-href" target="_blank" to="/support">
          <Icon token="work-order" />
        </Link>
       
      </div>
    </div>
  );
}
export default Header;
